// extracted by mini-css-extract-plugin
module.exports = {"moreResults":"Pagination_moreResults__F8Wgk","noMore":"Pagination_noMore__AkzNS"};